module.exports = __webpack_public_path__ + "img/4_1_kale_iletisim_banner.eb327b4d.jpg";